<template>
  <a-card :bordered="false">
    <div class="card-title">{{ title }}</div>
    <a-spin :spinning="loading">
      <div class="table-operator">
        <!--        <a-button v-action:add type="primary" @click="handleAdd">增加尿素记录</a-button>-->
        <!--        <SearchForm ref="SearchForm" @handleSubmit="handleSeachSubmit"/>-->
      </div>
      <s-table
          ref="table"
          rowKey="vr_id"
          :loading="isLoading"
          :columns="columns"
          :data="loadData"
          :pageSize="15"
          :scroll="{y:500}"
      >
        <div slot="jyd" slot-scope="text, item">
          <b>{{ text == 0 ? '仓库' : '其他' }}</b>
        </div>

        <div slot="jflx" slot-scope="text, item">
          <b v-if="item.jyd==1">{{ text == 0 ? '尿素卡' : '现金' }}</b>
        </div>
        <div slot="number" slot-scope="text, item">
          {{ text }}{{ item.tool_unit }}
        </div>
        <div slot="price" slot-scope="text, item">
          <span style="color: rgb(208, 5, 5)">￥</span>{{ text }}/{{ item.tool_unit }}
        </div>
        <div slot="total_amount" slot-scope="text, item">
          <span style="color: rgb(208, 5, 5)">￥</span>{{ text }}
        </div>

        <div slot="source" slot-scope="text, item">
          {{ text == 1 ? '后台' : '用户' }}
        </div>

        <div class="actions" slot="action" slot-scope="text, item">
          <a v-action:edit @click="handleEdit(item)">编辑</a>

          <a-popconfirm
              v-action:delete
              title="确认删除当前记录？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(item)"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </div>
      </s-table>
      <!--      <SaveForm :vehicleId="vehicle_id" ref="SaveForm" @handleSubmit="handleRefresh"/>-->
    </a-spin>
  </a-card>
</template>
<script>
import * as Api from '@/api/vehicle/ureaLog'
import {STable} from "@/components";
// import SearchForm from "./modules/SearchForm";
// import SaveForm from "./modules/SaveForm";

export default {
  props: ['vehicle_id', 'title'],
  name: "ShowToolList",
  components: {
    // SearchForm,
    // SaveForm,
    STable
  },
  data() {
    return {
      queryParam: {
        vehicle_id: this.vehicle_id
      },
      visible: false,
      loading: false,
      isLoading: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'vu_id',
          align: 'center',
          width: 60,
        },
        {
          title: '加注地点',
          dataIndex: 'jyd',
          align: 'center',
          width: 60,
          scopedSlots: {customRender: 'jyd'}
        },

        {
          title: '缴费类型',
          dataIndex: 'jflx',
          align: 'center',
          width: 100,
          scopedSlots: {customRender: 'jflx'}
        },
        {
          title: '数量（升）',
          dataIndex: 'jysl',
          align: 'center',
          width: 100,
          scopedSlots: {customRender: 'number'}
        },
        {
          title: '金额',
          dataIndex: 'amount',
          align: 'center',
          width: 100,
          scopedSlots: {customRender: 'total_amount'}
        },
        {
          title: '日期',
          dataIndex: 'jyrq',
          align: 'center',
          width: 140
        },
        {
          title: '提交时间',
          dataIndex: 'create_time',
          align: 'center',
          width: 140
        },
        // {
        //   title: '操作',
        //   width: 140,
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: {customRender: 'action'}
        // },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      }
    }
  },
  methods: {
    cancel() {
      this.visible = false
    },

    /**
     * 添加
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },

    handleDelete(item) {
      Api.deleted({vrId: item['vr_id']})
          .then((result) => {
            this.$message.success(result.message, 1.5)
            this.handleRefresh()
          })
    },

    /**
     * 搜索
     */
    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },


    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
  }
}
</script>
<style scoped lang="less">

</style>
